import { render } from "./AimSection.vue?vue&type=template&id=547e9c7e&scoped=true"
import script from "./AimSection.vue?vue&type=script&lang=js"
export * from "./AimSection.vue?vue&type=script&lang=js"

import "./AimSection.vue?vue&type=style&index=0&id=547e9c7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547e9c7e"]])

export default __exports__